import {
  RiFlightTakeoffFill,
  RiFlightLandFill,
  RiMapPinLine,
  RiTimeLine,
  RiErrorWarningLine,
  RiAlertLine,
  RiCloseCircleLine
} from "@remixicon/react";

import { Badge } from "@components/ui/Badge";

const statusConfig = {
  IN_TRANSIT: {
    label: "In Flight",
    textColor: "text-green-600",
    bgColor: "bg-green-50",
    icon: RiFlightTakeoffFill,
  },
  LAYOVER: {
    label: "Layover",
    textColor: "text-red-600",
    bgColor: "bg-red-50",
    icon: RiErrorWarningLine,
  },
  READY: {
    label: "Ready",
    textColor: "text-orange-600",
    bgColor: "bg-orange-50",
    icon: RiTimeLine,
  },
  DELAYED: {
    label: "Delayed",
    textColor: "text-red-600",
    bgColor: "bg-red-50",
    icon: RiErrorWarningLine,
  },
  COMPLETED: {
    label: "Arrived",
    textColor: "text-blue-600",
    bgColor: "bg-blue-50",
    icon: RiFlightLandFill,
  },
  POSITIONING: {
    label: "Positioning",
    textColor: "text-blue-600",
    bgColor: "bg-blue-50",
    icon: RiMapPinLine,
  },
  PENDING: {
    label: "Pending",
    textColor: "text-orange-600",
    bgColor: "bg-orange-50",
    icon: RiTimeLine,
  },
  DIVERTED: {
    label: "Diverted",
    textColor: "text-amber-600",
    bgColor: "bg-amber-50",
    icon: RiAlertLine,
  },
  CANCELLED: {
    label: "Cancelled",
    textColor: "text-gray-600",
    bgColor: "bg-gray-100",
    icon: RiCloseCircleLine,
  },
};

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.PENDING;
  const Icon = config.icon;

  return (
    <Badge
      className={`
        ${config.textColor} ${config.bgColor}
        px-2 py-1 text-xs font-medium
      `}
    >
      <Icon className="w-4 h-4" />
      {config.label}
    </Badge>
  );
};

export default StatusBadge;
